module.exports = __webpack_public_path__ + "static/media/icon-artdirection.cc10b6e9.svg";